type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

const OFFLINE_SUPPORTED_ENDPOINTS: Record<HttpMethod, RegExp[]> = {
  GET: [
    /^\/api\/v1\/accounts\b/,
    /^\/api\/v1\/categories\b/,
    /^\/api\/v1\/transactions\b/,
    /^\/api\/v1\/tasks\b/,
    /^\/api\/v1\/auth\/profile\b/,
    /^\/api\/v1\/objectives\b/,
    /^\/api\/v1\/key-results\b/,
    /^\/api\/v1\/investment-plans\b/,
    /^\/api\/v1\/investment-tracking\/ledgers\b/,
    /^\/api\/v1\/investment-tracking\/records\b/,
    /^\/api\/v1\/investment-advisory\/scenarios\b/,
    /^\/api\/v1\/investment-advisory\/goals\b/,
  ],
  POST: [
    /^\/api\/v1\/accounts$/,
    /^\/api\/v1\/categories$/,
    /^\/api\/v1\/transactions$/,
    /^\/api\/v1\/tasks$/,
    /^\/api\/v1\/recurring-transactions$/,
    /^\/api\/v1\/recurring-transactions\/\d+\/delete-scope$/,
    /^\/api\/v1\/objectives$/,
    /^\/api\/v1\/objectives\/\d+\/key-results$/,
    /^\/api\/v1\/key-results\/\d+\/indicators$/,
    /^\/api\/v1\/investment-plans$/,
    /^\/api\/v1\/investment-tracking\/ledgers$/,
    /^\/api\/v1\/investment-tracking\/records$/,
    /^\/api\/v1\/investment-advisory\/scenarios$/,
    /^\/api\/v1\/investment-advisory\/allocation$/,
    /^\/api\/v1\/investment-advisory\/goals$/,
  ],
  PUT: [
    /^\/api\/v1\/accounts\/\d+$/,
    /^\/api\/v1\/categories\/\d+$/,
    /^\/api\/v1\/transactions\/\d+$/,
    /^\/api\/v1\/transactions\/\d+\/mark-paid$/,
    /^\/api\/v1\/transactions\/\d+\/mark-unpaid$/,
    /^\/api\/v1\/tasks\/\d+$/,
    /^\/api\/v1\/tasks\/\d+\/complete$/,
    /^\/api\/v1\/tasks\/\d+\/uncomplete$/,
    /^\/api\/v1\/recurring-transactions\/\d+$/,
    /^\/api\/v1\/investment-plans\/\d+$/,
  ],
  PATCH: [
    /^\/api\/v1\/accounts\/\d+$/,
    /^\/api\/v1\/categories\/\d+$/,
    /^\/api\/v1\/transactions\/\d+$/,
    /^\/api\/v1\/tasks\/\d+$/,
    /^\/api\/v1\/recurring-transactions\/\d+$/,
    /^\/api\/v1\/objectives\/\d+$/,
    /^\/api\/v1\/key-results\/\d+$/,
  ],
  DELETE: [
    /^\/api\/v1\/accounts\/\d+$/,
    /^\/api\/v1\/categories\/\d+$/,
    /^\/api\/v1\/transactions\/\d+$/,
    /^\/api\/v1\/tasks\/\d+$/,
    /^\/api\/v1\/recurring-transactions\/\d+$/,
    /^\/api\/v1\/investment-plans\/\d+$/,
  ],
};

const BACKEND_REQUIRED_PATHS: RegExp[] = [
  /^\/profile\b/,
  /^\/forgot-password\b/,
  /^\/reset-password\b/,
  /^\/register\b/,
  /^\/login\b/,
];

const BACKEND_REQUIRED_ENDPOINTS: RegExp[] = [
  /^\/api\/v1\/auth\/(login|register|forgot-password|reset-password)\b/,
  /^\/api\/v1\/auth\/profile\b/,
  /^\/api\/v1\/investment-plans\/\d+\/projection\b/,
  /^\/api\/v1\/investment-plans\/\d+\/depletion-alert\b/,
  /^\/api\/v1\/investment-tracking\/indicators\b/,
  /^\/api\/v1\/investment-advisory\/scenarios\/compare\b/,
  /^\/api\/v1\/investment-advisory\/fi-indicators\b/,
];

export function isOfflineSupportedRequest(method: HttpMethod, url: string): boolean {
  const patterns = OFFLINE_SUPPORTED_ENDPOINTS[method] || [];
  return patterns.some((pattern) => pattern.test(url));
}

export function isBackendRequiredPath(pathname: string): boolean {
  return BACKEND_REQUIRED_PATHS.some((pattern) => pattern.test(pathname));
}

export function isBackendRequiredEndpoint(url: string): boolean {
  return BACKEND_REQUIRED_ENDPOINTS.some((pattern) => pattern.test(url));
}

export function getOfflineRestrictionMessage(url: string): string {
  if (/\/api\/v1\/investment-plans\/\d+\/projection\b/.test(url)) {
    return 'Projecoes de investimento exigem conexão com o backend.';
  }
  if (/\/api\/v1\/investment-tracking\/indicators\b/.test(url)) {
    return 'Indicadores de tracking exigem conexão com o backend.';
  }
  if (/\/api\/v1\/investment-advisory\/scenarios\/compare\b/.test(url)) {
    return 'Comparacao de cenarios exige conexao com o backend.';
  }
  if (/\/api\/v1\/investment-advisory\/fi-indicators\b/.test(url)) {
    return 'Indicadores de independencia financeira exigem conexao com o backend.';
  }
  if (/\/api\/v1\/auth\/(login|register|forgot-password|reset-password)\b/.test(url)) {
    return 'Autenticação exige conexão com o backend.';
  }
  if (/\/api\/v1\/auth\/profile\b/.test(url)) {
    return 'Atualização de perfil exige conexão com o backend.';
  }
  return 'Funcionalidade indisponível offline. Conecte-se para continuar.';
}
